import { SET_ESS_IS_VISIBLE } from './constants';

export const setESSIsVisible = isVisible => ({
    type: SET_ESS_IS_VISIBLE,
    isVisible,
});



// WEBPACK FOOTER //
// ./src/containers/Inputs/ESS/actions.js